import React, { useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { useAuth } from "../Store/AuthContext";
import { Helmet } from "react-helmet";
import $ from "jquery";

import { ServiceFetchData } from "../APIS/FetchAPIs";
// import Preloader from "../Component/Preloader/Preloader";

export default function Header() {
  const {RendomTokenfetch, webSetting } = useAuth();
  const [ServiceData] = ServiceFetchData(RendomTokenfetch);

  const navigaṭe = useNavigate();

  const NotMathURL = /[’/`~!#*$@%+=.,^&(){}[\]|;:”<>?\\]/g;
  const patthnameURL = useLocation();
  useEffect(() => {
    if (NotMathURL.test(patthnameURL.search)) {
      navigaṭe("/page-not-found");
    }
  });

  // Toggle mobile navigation
  function toggleMobileNavigation() {
    var navbar = $("#navbar");
    var openBtn = $(".navbar-header .open-btn");
    var closeBtn = $("#navbar .close-navbar");

    openBtn.on("click", function () {
      if (!navbar.hasClass("slideInn")) {
        navbar.addClass("slideInn");
      }
      return false;
    });

    closeBtn.on("click", function () {
      if (navbar.hasClass("slideInn")) {
        navbar.removeClass("slideInn");
      }
      return false;
    });
  }

  toggleMobileNavigation();

  // Add class for small navigation
  function addClassForSmallNav() {
    var windowWidth = window.innerWidth,
      mainNav = $("#navbar > ul");

    if (windowWidth < 992) {
      mainNav.addClass("small-nav");
    } else {
      mainNav.removeClass("small-nav");
    }
  }

  // Functionality for dropdown open close ect
  function smallNavFunctinality() {
    if ($(".small-nav").length) {
      var navigation = $(".small-nav");

      var subMenuLink = navigation.find(".sub-menu > a");
      var subSubMenuLink = navigation.find(".sub-sub-menu > a");
      var subMenu = subMenuLink.siblings("ul");
      var subSubMenu = subSubMenuLink.next("ul");

      subMenu.hide();
      subSubMenu.hide();

      subMenuLink.on("click", function (e) {
        var $this = $(this);
        e.preventDefault();
        $this.siblings().slideToggle();
        e.stopImmediatePropagation();
      });

      subSubMenuLink.on("click", function (f) {
        var $this = $(this);
        f.preventDefault();
        $this.siblings().slideToggle();
        f.stopImmediatePropagation();
      });
    }
  }

  $(window).on("resize", function () {
    addClassForSmallNav();

    smallNavFunctinality();
  });

  return (
    <>
      <Helmet>
        <link rel="icon" type="image/x-icon" href={webSetting.favicon} />
      </Helmet>
      {/* <Preloader /> */}
      <header className="site-header-style2">
        <div className="upper-topbar">
          <div className="container-fluid">
            <div className="row">
              <div className="col col-md-9 contact-info">
                <ul>
                  <li>
                    <Link to={`mailto:${webSetting?.email || ""}`}>
                      <i className="fa fa-envelope-o"></i>{" "}
                      {webSetting?.email || ""}
                    </Link>
                  </li>
                  <li>
                    <Link to={`tel:+${webSetting?.number || ""}`}>
                      <i className="fa fa-phone"></i> +
                      {webSetting?.number || ""}
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col col-md-3">
                <ul className="social-links">
                  <li>
                    <Link
                      to={webSetting?.facebook || ""}
                      target="blank"
                      rel="noreferrer"
                      aria-label="Go to Facebook Account"
                    >
                      <i className="fa fa-facebook"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={webSetting?.instagram || ""}
                      target="blank"
                      aria-label="Go to Instagram Account"
                      rel="noreferrer"
                    >
                      <i className="fa fa-instagram"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={webSetting?.linkedIn || ""}
                      target="blank"
                      rel="noreferrer"
                      aria-label="Go to Linkedin Account"
                    >
                      <i className="fa fa-linkedin"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={webSetting?.twitter || ""}
                      target="blank"
                      rel="noreferrer"
                      aria-label="Go to Twitter Account"
                    >
                      <i className="fa fa-twitter"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <nav className="navigation navbar navbar-default">
          <div className="container-fluid">
            <div className="navbar-header">
              <button type="button" className="open-btn">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>

              <Link
                to="/"
                className="logo"
                rel="noreferrer"
                aria-label="This is a Website Logo"
              >
                {webSetting.website_logo !== "" ? (
                  <img
                    src={webSetting.website_logo}
                    alt=""
                    className="img img-responsive"
                    loading="lazy"
                  />
                ) : (
                  ""
                )}
              </Link>
            </div>
            <div id="navbar" className="navbar-collapse collapse navbar-right">
              <button
                className="close-navbar"
                aria-label="Close Navsitebar"
                id="close_navbar"
              >
                <i className="fa fa-close"></i>
              </button>
              <ul className="nav navbar-nav">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/about">About</NavLink>
                </li>
                <li className="sub-menu">
                  <NavLink to="/services">
                    Services{" "}
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </NavLink>

                  <ul>
                    {ServiceData.length > 0
                      ? ServiceData.map((service, index) => (
                          <li key={index}>
                            <Link to={`/service/${service.slug}`}>
                              {service.title}
                            </Link>
                          </li>
                        ))
                      : ""}
                  </ul>
                </li>

                <li className="">
                  <NavLink to="/blogs">Blogs</NavLink>
                </li>
                <li>
                  <NavLink to="/contact">Contact</NavLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}
